// TODO: TO BE REMOVED ONCE OLD UI NO LONGER VALID
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface AppConfigState {
    config: Record<string, unknown>;
}

const initialState: AppConfigState = {
    config: {},
};

const appConfigSlice = createSlice({
    name: 'appConfig',
    initialState,
    reducers: {
        setAppConfig(state, action: PayloadAction<Record<string, unknown>>) {
            state.config = action.payload;
        },
    },
});

export const { setAppConfig } = appConfigSlice.actions;
export default appConfigSlice.reducer;
